import { useAppContext } from "../../context";
import Logo from "../../assets/1click-logo.png";
import { ArrowLeftIcon, HelpIcon } from "../../icons";

const headerItems = [
  {
    step: "quiz",
    title: "1. Your home",
  },
  {
    step: "quote,selected",
    title: "2. Your quote",
  },
  {
    step: "confirmation",
    title: "3. Confirmation",
  },
  {
    step: "outOfServiceArea",
    title: "",
  },
  {
    step: "customerIsRenter",
    title: "",
  },
  {
    step: "customerRoomPlusFive",
    title: "",
  }
];

export const Header = () => {
  const { setCurrentStep, currentStep } = useAppContext();

  const currentIndex = headerItems.findIndex((item) =>
    item.step.includes(currentStep)
  );

  const handleBack = () => {
    if (currentStep === "quiz" || currentStep === "quote") {
      return;
    }

    if (currentStep === "confirmation") {
      setCurrentStep("selected");
    } else if (currentStep === "selected") {
      setCurrentStep("quote");
    }
  };

  return (
    <div className="tw-max-w-[1420px] tw-px-3 tw-mx-auto tw-my-6">
      {process.env.REACT_APP_API_ENVIRONMENT !== "production" && (
        <p>
          {process.env.REACT_APP_API_ENVIRONMENT || "Unknown"} environment
        </p>
      )}
      <div className="tw-flex tw-gap-x-2">
        <button
          className="tw-bg-blue tw-text-white tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-w-[50px] tw-h-[50px]"
          onClick={handleBack}
        >
          <ArrowLeftIcon />
        </button>
        <div className="tw-h-[50px] tw-flex tw-items-center tw-w-full tw-bg-white tw-rounded-full">
          <div className="tw-bg-blue tw-rounded-full md:tw-px-8 tw-px-5 tw-h-full tw-flex tw-items-center md:tw-mr-5 tw-w-full md:tw-w-auto">
            <img src={Logo} alt="logo" className="tw-w-[93px]" />
            <div className="md:tw-hidden tw-ml-5 tw-gap-x-12 tw-text-white">
              {
                <div>
                  <span className="tw-text-sm">
                    {currentIndex + 1} of {headerItems.length} -{" "}
                  </span>
                  <span className="tw-font-semibold">
                    {headerItems[currentIndex].title}
                  </span>
                </div>
              }
            </div>
            <a
              href="tel:1-800-458-1289"
              className="md:tw-hidden tw-inline-flex tw-text-white tw-ml-auto tw-w-4 tw-h-4 tw-items-center tw-justify-center"
            >
              <HelpIcon />
            </a>
            <div className="tw-hidden md:tw-flex tw-ml-[70px] tw-gap-x-12">
              {headerItems.map((item, index) =>
                index <= currentIndex ? (
                  <div key={index} className="tw-text-white tw-font-semibold">
                    {item.title}
                  </div>
                ) : null
              )}
            </div>
          </div>
          <div className="tw-hidden md:tw-flex tw-gap-x-12">
            {headerItems.map((item, index) =>
              index > currentIndex ? (
                <div key={index} className="tw-text-blue">
                  {item.title}
                </div>
              ) : null
            )}
          </div>
          <a
            href="tel:1-800-458-1289"
            className="tw-hidden md:tw-inline-flex tw-bg-blue tw-text-white tw-rounded-full tw-h-[38px] tw-px-4 tw-items-center tw-gap-x-2 tw-ml-auto"
          >
            1-800-458-1289
          </a>
        </div>
      </div>
    </div>
  );
};
